module.exports = __webpack_public_path__ + "media/newstyle/images/icon-a4-47858b8cdbcab4bd434942fa85261410.svg";